import { last, initial } from 'lodash';
import { Component as ComponentContainer } from '@styles/layout';
import { Theme, useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import { TripTypes, Page } from '@model/common';
import { TourDetails } from '@model/tours';
import { DestinationLinkBuilder, LinkItem } from '@model/iceberg';
import { ExperienceProductTile } from '@components/product/experiences/experience-product-tile';

interface TourGroupGridProps {
  packages: Array<TourDetails>;
}

export const TourGroupGrid = ({ packages }: TourGroupGridProps) => {
  const theme: Theme = useTheme();

  const renderTiles = () =>
    packages.map((tour) => {
      const { name, path, price, days, image } = tour;
      const splitPath = path.split('/');
      const experiencePath = last(splitPath);
      const placePath = initial(splitPath);
      if (!experiencePath || !placePath || !placePath.length) {
        return null;
      }

      const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
      const link: LinkItem = builder.getGuideLink(
        placePath.join('/'),
        experiencePath,
        Page.EXPERIENCES,
        TripTypes.HOLIDAYS
      );
      return (
        <Grid item xs={12} md={6} lg={4} xl={3} key={experiencePath}>
          <ExperienceProductTile name={name} price={price} imageUrl={image} link={link} days={days} />
        </Grid>
      );
    });
  return (
    <ComponentContainer>
      <Grid container spacing={theme!.custom.gridSpacing.default}>
        {renderTiles()}
      </Grid>
    </ComponentContainer>
  );
};
